<template>
  <b-container class="card-container">
    <b-card>
      <h3>{{profile.team.name}}</h3>
      <p>Your team is on the <strong>{{profile.team.plan}}</strong> <strong v-if='profile.team.trial'> trial </strong> plan.</p>
      <p>Your team can have <strong>{{profile.team.plan_quantity}} members</strong>.</p>
      <p>Each member gets <strong>{{profile.team.max_usage_in_period_per_user}} videos</strong> per month. Resets on {{profile.team.current_period_end | date}}.</p>
      <p>Each member has a max of 1 clone, 5 videos</p>
      <p><b-link :to="{name: 'billing'}">Upgrade your subscription</b-link> to add more members or increase videos per month.</p>
    </b-card>

    <h4>Members</h4>
    <p>Invite and manage team members</p>
    <b-card no-body>
      <template v-slot:header>
        <b-button size="sm" variant="primary float-right" v-b-modal.add_member>Add</b-button>
      </template>

      <!-- , 'actions' -->

      <b-table show-empty :items="items" :fields="['email', 'role', 'status', 'usage', 'created']">
        <template v-slot:cell(updated)='data'>
          {{data.value | date}}
        </template>
        <template v-slot:cell(created)='data'>
          {{data.value | date}}
        </template>
        <template v-slot:cell(usage)='data'>
          <span v-if="profile.team.current_period && profile.team.current_period.id && profile.team.current_period.usage[data.item.uid] && profile.team.current_period.usage[data.item.uid].recipients">{{profile.team.current_period.usage[data.item.uid].recipients}}</span><span v-else>0</span> / {{profile.team.max_usage_in_period_per_user}}
        </template>
        <template v-slot:cell(actions)='data'>
          <b-button :disabled="profile.email === data.item.email" variant='danger' size='sm' @click='delete_member(data.item)'>Delete</b-button>
        </template>
        <!-- <template v-slot:cell(name)='data'>
          <b-link :to="{name: collection, params: {id: data.item.id}}">{{data.value}}</b-link>
        </template> -->
      </b-table>

      <b-modal v-if="items.length < profile.team.plan_quantity" id="add_member" hide-footer title="Add member" header-bg-variant="light" variant='light' button-size="lg" centered size="sm" class="text-center">
        <b-form @submit.stop.prevent="add_member">
          <b-form-group label="Email:">
            <b-form-input v-model="email" required placeholder="john@example.com" type='email'></b-form-input>
          </b-form-group>
          <b-form-group label="Role:" description='Members can only edit projects they have created. Managers can edit all team projects. Admins can edit all team projects and billing.'>
            <b-form-select v-model="role" required :options="['manager', 'member']" ></b-form-select>
          </b-form-group>

          <LoadingButton type="submit" variant='primary' :loading="is_saving">Invite</LoadingButton>
        </b-form>
      </b-modal>

      <b-modal v-else id="add_member" hide-footer title="Add member" header-bg-variant="light" variant='light' button-size="lg" centered size="sm" class="text-center">
        <p>You've reached the maximum number ({{items.length}} of {{profile.team.plan_quantity}}) of members. Upgrade to add more</p>
      </b-modal>
    </b-card>
  </b-container>
</template>

<script>

import { db, auth } from '@/main.js'
import api from '@/lib/api.js'

export default {
  metaInfo: {title: 'Team'},
  props: ['profile'],
  firestore: function () {
    return {
      items: db.collection('team').doc(this.profile.team.id).collection('member').orderBy('created', 'desc')
    }
  },
  data() {
    return {
      is_saving: false,
      items: [],
      role: 'member',
      email: null
    }
  },
  methods: {
    async add_member() {
      this.is_saving = true

      await db.collection('team').doc(this.profile.team.id).collection('member').add({created: new Date(), updated: new Date(), email: this.email, role: this.role, status: 'enabled'})

      this.role = 'member'
      this.email = null
      this.is_saving = false

      this.$bvModal.hide('add_member')

      this.$swal({title: 'Added', text: "Tell your team member to login at https://app.vidon.ai/", icon: 'success'})
    },
    async delete_member(item) {
      let result = await this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      })

      if (!result.value) {
        return
      }

      await db.collection('team').doc(this.profile.team.id).collection('member').doc(item.id).delete()
    }
  },
}
</script>

<style scoped>

</style>
